import React, { useState, useEffect } from 'react';
import {
    Row, Col, Form, Label, Input, Card, CardBody,
    Container, Button, FormFeedback, InputGroup
} from "reactstrap";
import { toast } from "react-toastify";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useNavigate } from "react-router-dom";
import "./CustomCheckbox.css";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

const PromotionsCreate = () => {
    const [title, setTitle] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [description, setDescription] = useState('');
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [loading, setloading] = useState(false);

    const navigate = useNavigate();

    const [validation, setValidation] = useState({
        title: null,
        image: null,
        description: null,
        startDate: null,
        endDate: null,
    });

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);

            const previewUrl = URL.createObjectURL(file);
            setImagePreview(previewUrl);
        } else {
            setImageFile(null);
            setImagePreview(null);
        }
    };

    const validateFields = () => {
        let isValid = true;
        const newValidation = {};

        newValidation.title = title.trim() !== '';
        newValidation.startDate = startDate !== '';
        newValidation.endDate = endDate !== '';
        newValidation.description = description.trim() !== '';
        newValidation.image = imageFile !== null;

        setValidation(newValidation);

        Object.values(newValidation).forEach(v => {
            if (v !== true) isValid = false;
        });

        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateFields()) return;

        setloading(true);

        const formData = new FormData();
        formData.append('title', title);
        formData.append('start_date', startDate);
        formData.append('end_date', endDate);
        formData.append('description', description);
        if (imageFile) formData.append('image', imageFile);

        try {
            const token = localStorage.getItem("authToken");
            const response = await fetch(`${process.env.REACT_APP_WEB_APP_URL}/api/web/promotions/create`, {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                body: formData,
            });

            const data = await response.json();

            if (response.status === 200) {
                toast.success('Promotion created successfully', { autoClose: 3000 });
                setloading(false);
                navigate(`/promotions`);
            } else if (response.status === 422) {
                if (data?.errors) {
                    setloading(false);
                    Object.values(data.errors).forEach((errorArr) => {
                        errorArr.forEach((errMsg) => {
                            toast.error(errMsg, { autoClose: 3000 });
                        });
                    });
                } else {
                    setloading(false);
                    toast.error(data?.message || 'Validation failed', { autoClose: 3000 });
                }
            } else {
                setloading(false);
                toast.error(data?.message || `Error: ${response.statusText}`, { autoClose: 3000 });
            }
        } catch (err) {
            setloading(false);
            console.log(err);
            toast.error("Failed to create promotion", { autoClose: 3000 });
        }
    };

    document.title = "Add Promotion | Moeen";

    return (
        <div className="page-content">
            <Container fluid={true}>
                <Breadcrumbs maintitle="Home" title="Promotions" breadcrumbItem='Add Promotion' />

                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardBody>
                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col md="6">
                                            {/* Title */}
                                            <div className="mb-3">
                                                <Label>Title</Label>
                                                <Input
                                                    type="text"
                                                    placeholder="Enter material name"
                                                    value={title}
                                                    onChange={e => setTitle(e.target.value)}
                                                    valid={validation["title"] === true}
                                                    invalid={validation["title"] !== true && validation["title"] !== null}
                                                />
                                                <FormFeedback tooltip>Title is required.</FormFeedback>
                                            </div>
                                        </Col>

                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label>Image</Label>
                                                <Input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={handleImageChange}
                                                    invalid={validation.image === false}
                                                />
                                                <FormFeedback tooltip>Please upload an image.</FormFeedback>

                                                {imagePreview && (
                                                    <div style={{ marginTop: '10px' }}>
                                                        <img
                                                            src={imagePreview}
                                                            alt="Preview"
                                                            style={{ maxWidth: '100%', maxHeight: '200px', borderRadius: 4, border: '1px solid #ddd' }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label>Start Date</Label>
                                                <InputGroup>
                                                    <Flatpickr
                                                        className="form-control d-block"
                                                        placeholder="dd M, yyyy"
                                                        value={startDate}
                                                        onChange={(date) => {
                                                            if (date[0]) {
                                                                setStartDate(date[0].toISOString().split("T")[0]);
                                                            }
                                                        }}
                                                        options={{
                                                            altInput: true,
                                                            altFormat: "F j, Y",
                                                            dateFormat: "Y-m-d",
                                                            defaultDate: new Date(),
                                                            minDate: "today"
                                                        }}
                                                    />
                                                </InputGroup>
                                                {validation.startDate === false && (
                                                    <FormFeedback tooltip>Start Date is required.</FormFeedback>
                                                )}
                                            </div>
                                        </Col>
                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label>End Date</Label>
                                                <InputGroup>
                                                    <Flatpickr
                                                        className="form-control d-block"
                                                        placeholder="dd M, yyyy"
                                                        value={endDate}
                                                        onChange={(date) => {
                                                            if (date[0]) {
                                                                setEndDate(date[0].toISOString().split("T")[0]);
                                                            }
                                                        }}
                                                        options={{
                                                            altInput: true,
                                                            altFormat: "F j, Y",
                                                            dateFormat: "Y-m-d",
                                                            defaultDate: new Date(),
                                                            minDate: "today"
                                                        }}
                                                    />
                                                </InputGroup>
                                                {validation.endDate === false && (
                                                    <FormFeedback tooltip>End Date is required.</FormFeedback>
                                                )}
                                            </div>
                                        </Col>

                                        {/* Description */}
                                        <Col md="12">
                                            <div className="mb-3">
                                                <Label>Description</Label>
                                                <Input
                                                    type="textarea"
                                                    rows="5"
                                                    placeholder="Enter description"
                                                    value={description}
                                                    onChange={e => setDescription(e.target.value)}
                                                    valid={validation["description"] === true}
                                                    invalid={validation["description"] !== true && validation["description"] !== null}
                                                />
                                                <FormFeedback tooltip>Description is required.</FormFeedback>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col className="text-end">
                                            <Button type="submit" color="primary" disabled={loading}>
                                                {loading ? (
                                                    <>
                                                        <span
                                                            className="spinner-border spinner-border-sm me-2"
                                                            role="status"
                                                            aria-hidden="true"
                                                        ></span>
                                                        Saving
                                                    </>
                                                ) : (
                                                    "Save"
                                                )}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default PromotionsCreate;
